import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface MobileWarningDialogProps {
  open: boolean;
  onClose: () => void;
}

export function MobileWarningDialog({ open, onClose }: MobileWarningDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="w-[80%] max-w-[325px] p-0 gap-0 border-none bg-white rounded-[16px]"
        hideCloseButton
      >
        <div className="flex flex-col items-center p-6 text-center">
          <div className="mb-6 mt-12">
            <svg
              aria-hidden="true"
              width="134"
              height="134"
              viewBox="0 0 134 134"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.972656 66.9365C0.972656 84.5165 7.95625 101.376 20.3871 113.807C32.818 126.238 49.6779 133.222 67.2578 133.222C84.8378 133.222 101.698 126.238 114.129 113.807C126.559 101.376 133.543 84.5165 133.543 66.9365C133.543 49.3566 126.559 32.4967 114.129 20.0658C101.698 7.63497 84.8378 0.651367 67.2578 0.651367C49.6779 0.651367 32.818 7.63497 20.3871 20.0658C7.95625 32.4967 0.972656 49.3566 0.972656 66.9365Z"
                fill="#F2F2F4"
              />
              <path
                d="M110.389 47.8052H23.348C22.469 47.8052 21.626 48.1544 21.0044 48.7759C20.3829 49.3974 20.0337 50.2404 20.0337 51.1194V107.271H113.703V51.1194C113.703 50.2404 113.354 49.3974 112.732 48.7759C112.111 48.1544 111.268 47.8052 110.389 47.8052Z"
                fill="white"
                stroke="#071855"
                strokeWidth="1.65713"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M107.09 54.4182H26.7373L26.6445 107.272H107.09V54.4182Z"
                fill="white"
              />
              <path
                d="M107.09 54.4182H26.7373L26.6445 107.272H107.09V54.4182Z"
                stroke="#071855"
                strokeWidth="1.65713"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                opacity="0.15"
                d="M16.1758 121.493C16.1758 121.928 17.544 122.358 20.2022 122.759C22.8605 123.16 26.7567 123.524 31.6685 123.831C36.5803 124.138 42.4115 124.382 48.8291 124.548C55.2467 124.714 62.125 124.799 69.0714 124.799C76.0177 124.799 82.896 124.714 89.3136 124.548C95.7312 124.382 101.562 124.138 106.474 123.831C111.386 123.524 115.282 123.16 117.94 122.759C120.599 122.358 121.967 121.928 121.967 121.493C121.967 121.059 120.599 120.629 117.94 120.228C115.282 119.827 111.386 119.463 106.474 119.156C101.562 118.849 95.7312 118.605 89.3136 118.439C82.896 118.273 76.0177 118.188 69.0714 118.188C62.125 118.188 55.2467 118.273 48.8291 118.439C42.4115 118.605 36.5803 118.849 31.6685 119.156C26.7567 119.463 22.8605 119.827 20.2022 120.228C17.544 120.629 16.1758 121.059 16.1758 121.493Z"
                fill="#071855"
              />
              <path
                d="M121.968 113.885H11.7686V108.93C11.7686 108.491 11.9431 108.069 12.2539 107.758C12.5647 107.448 12.9862 107.273 13.4257 107.273H120.311C120.75 107.273 121.172 107.448 121.482 107.758C121.793 108.069 121.968 108.491 121.968 108.93V113.885Z"
                fill="white"
                stroke="#071855"
                strokeWidth="1.65713"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M121.968 113.886C111.732 116.809 101.14 118.292 90.4955 118.292H43.2408C32.5963 118.292 22.0037 116.809 11.7686 113.886H121.968Z"
                fill="white"
                stroke="#071855"
                strokeWidth="1.65713"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M57.1653 77.9335C57.0463 78.0526 57.0463 78.2457 57.1653 78.3647L61.2595 82.459C61.3786 82.5781 61.3786 82.7712 61.2595 82.8902L57.1635 86.9864C57.0444 87.1054 57.0445 87.2985 57.1635 87.4176L62.7692 93.0234C62.8883 93.1424 63.0813 93.1424 63.2004 93.0234L73.3315 82.8921C73.4505 82.773 73.4505 82.5799 73.3315 82.4608L63.2004 72.3295C63.0813 72.2105 62.8883 72.2105 62.7692 72.3295L57.1653 77.9335ZM60.1822 78.3646C60.0631 78.2455 60.0631 78.0524 60.1822 77.9334L62.7688 75.3467C62.8879 75.2276 63.0809 75.2276 63.2 75.3467L65.7866 77.9334C65.9057 78.0524 65.9057 78.2455 65.7866 78.3646L63.2 80.9512C63.0809 81.0703 62.8879 81.0703 62.7688 80.9512L60.1822 78.3646ZM67.7268 79.8724C67.6077 79.7533 67.4146 79.7533 67.2956 79.8724L64.709 82.459C64.5899 82.5781 64.5899 82.7712 64.709 82.8902L67.2956 85.4769C67.4146 85.596 67.6077 85.596 67.7268 85.4769L70.3134 82.8902C70.4324 82.7712 70.4324 82.5781 70.3134 82.459L67.7268 79.8724ZM60.1822 87.417C60.0631 87.2979 60.0631 87.1049 60.1822 86.9858L62.7688 84.3992C62.8879 84.2801 63.0809 84.2801 63.2 84.3992L65.7866 86.9858C65.9057 87.1049 65.9057 87.2979 65.7866 87.417L63.2 90.0036C63.0809 90.1227 62.8879 90.1227 62.7688 90.0036L60.1822 87.417ZM70.7451 76.856C70.6261 76.7369 70.6261 76.5439 70.7451 76.4248L73.3317 73.8382C73.4508 73.7191 73.6439 73.7191 73.7629 73.8382L76.3495 76.4248C76.4686 76.5439 76.4686 76.7369 76.3495 76.856L73.7629 79.4427C73.6439 79.5617 73.4508 79.5617 73.3317 79.4427L70.7451 76.856ZM73.7627 85.9105C73.6437 85.7914 73.4506 85.7914 73.3315 85.9105L70.7449 88.4971C70.6259 88.6162 70.6259 88.8092 70.7449 88.9283L73.3315 91.515C73.4506 91.634 73.6437 91.634 73.7627 91.515L76.3493 88.9283C76.4684 88.8092 76.4684 88.6162 76.3493 88.4971L73.7627 85.9105Z"
                fill="#EB5528"
              />
            </svg>
          </div>
          <h2 className="text-base font-medium mb-4 text-[#071855] leading-[100%] tracking-[0.25px] text-center align-middle">
            Desktop Only Platform
          </h2>
          <p className="text-[15px] font-normal leading-[20px] tracking-[-0.25px] text-center text-[#6D6B70] mb-6">
            Optimized for desktop, may not work well on mobile. Please use a desktop for
            the best experience
          </p>
          <Button
            className="w-full bg-[#EB5528] hover:bg-[#F56538] text-white"
            onClick={onClose}
          >
            I understand, proceed
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
